<template>
	<div>
		<div class="panel panel-info">
			<div class="panel-heading"><h4 class="panel-title"><i class="fa fa-book"></i>填写课件基础信息</h4></div>
			<div class="panel-body">
					<form class="form-horizontal">
						<div class="col-sm-12">
							<div class="form-group">
								<label class="col-sm-1 control-label"> <span class="required">*</span>选择课程</label>
								<div class="col-sm-5">
										<BootstrapCombobox :data="kcList" data-vv-as="课程" name="kcId"  text-field="kcmc" value-field="id" v-model="model.kcId" :format-option="(item)=>(item.kcdm+'-'+item.kcmc)" placeholder="-课程筛选-"></BootstrapCombobox>
										<span class="error_validate_msg"><em>{{ errors.first('kcId') }}</em></span>
								</div>
							</div>
						</div>
						<div class="col-sm-12">
							<div class="form-group">
							    <label class="col-sm-1 control-label"> <span class="required">*</span>课件讲师</label>
							    <div class="col-sm-5">
							        <input type="text" v-model="model.jsxm" name="jsxm"
							               v-validate="{required:true,max:50}" class="form-control" data-vv-as="课件讲师"
							               placeholder=""/>
							        <span class="error_validate_msg"><em>{{ errors.first('jsxm') }}</em></span>
							    </div>
							</div>
						</div>
						<div class="col-sm-12">
							<div class="form-group">
							    <label class="col-sm-1 control-label">讲师简介</label>
							    <div class="col-sm-7">
									<textarea class="form-control" v-model="model.jsjj" rows="5"></textarea>
							    </div>
							</div>
						</div>
						<div class="col-sm-12">
							<div class="form-group">
							    <label class="col-sm-1 control-label"><span class="required">*</span>课件状态</label>
							    <div class="col-sm-5">
										<select v-model="model.zt" class="form-control">
											<option value="OK">开放</option>
											<option value="BLOCK">关闭</option>
										</select>
							    </div>
							</div>
						</div>
						<div class="col-sm-12">
							<div class="form-group">
							    <label class="col-sm-1 control-label">课程介绍</label>
							    <div class="col-sm-7">
							        <textarea class="form-control" v-model="model.kjjs" rows="5"></textarea>
							    </div>
							</div>
						</div>
					</form>
			</div>
			<!-- 课件章节信息 -->
			<div class="panel-heading"><h4 class="panel-title"><i class="fa fa-bookmark"></i>填写课件章节内容信息</h4></div>
			<div class="panel-body">
				<button class="btn btn-info btn-sm" @click="changeToggle('import')" type="button" v-if="action=='form'"  style="margin-left:15px"><i class="fa fa-file-excel-o" aria-hidden="true"></i>切换导入</button>
				<button class="btn btn-info btn-sm"  @click="changeToggle('form')" type="button" v-if="action=='import'" style="margin-left:15px"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>切换表单</button>
				<!-- 一个章节的模板 -->
				<template v-if="action == 'form'">
				<div class="panel panel-primary" v-for="(chapter,indexa) in chapterList" :key="'chapter_id_'+indexa" style="margin: 15px;">
					<div class="panel-body">

						<div class="row">
							<div class="col-sm-12">
								<form class="form-horizontal">
									<div class="col-sm-10">
										<div class="form-group">
											<label class="col-sm-1 control-label"><span class="required">*</span>第{{indexa+1}}章</label>
											<div class="col-sm-7">
												<input type="text" v-model="chapter.name" :name="'chapter_name'+indexa"
												       v-validate="{required:true,max:100}" class="form-control" data-vv-as="章节名称"
												       placeholder="请输入章节名称"/>
												<span class="error_validate_msg"><em>{{ errors.first('chapter_name'+indexa) }}</em></span>
											</div>
											<div class="col-sm-3" style="padding-left: 1px;">
												<button @click="addChapter()" type="button"  class="btn btn-primary btn-sm" title="添加章" style="padding: 4px 4px;"><i class="fa fa-plus" aria-hidden="true"></i>添加章</button>
												<button @click="delChapter(indexa)" type="button"  class="btn btn-danger btn-sm" title="删除章" style="padding: 4px 4px;margin-left: 5px;"><i class="fa fa-times" aria-hidden="true"></i>删除章</button>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>

						<div class="row" v-if="chapter.lessons && chapter.lessons.length> 0">
							<div class="col-sm-12" v-for="(lesson,indexb) in chapter.lessons" :key="'lessson_id_'+indexb">
								<!-- 课时信息模板 -->
								<div class="panel panel-default" style="margin: 15px;">
									<div class="panel-heading">
										第({{indexb+1}})课时
										<button @click="addLesson(chapter)" type="button"  class="btn btn-primary btn-sm" title="添加课件" style="padding: 0px 10px;"><i class="fa fa-plus" aria-hidden="true"></i>添加课件</button>
										<button @click="delLesson(chapter.lessons,indexb)" type="button"  class="btn btn-danger btn-sm pull-right" title="删除" style="padding: 0px 10px;"><i class="fa fa-times" aria-hidden="true"></i>删除</button>
									</div>
									<div class="panel-body">
											<form class="form-horizontal">
												<div class="row">
													<div class="col-sm-6">
														<div class="form-group">
															<label class="col-sm-3 control-label"><span class="required">*</span>课时名称</label>
															<div class="col-sm-9">
																<input type="text" v-model="lesson.lesson_name" v-validate="{required:true,max:100}" :name="'lesson_name'+indexb" class="form-control" data-vv-as="课时名称"     />
																<span class="error_validate_msg"><em>{{ errors.first('lesson_name'+indexb) }}</em></span>
															</div>
														</div>
													</div>
													<div class="col-sm-6">
														<div class="form-group">
															<label class="col-sm-3 control-label"><span class="required">*</span>课时介绍</label>
															<div class="col-sm-9">
																<input type="text" v-model="lesson.lesson_remark" v-validate="{required:true,max:100}" :name="'lesson_remark'+indexb" class="form-control" data-vv-as="课时介绍"     />
																<span class="error_validate_msg"><em>{{ errors.first('lesson_remark'+indexb) }}</em></span>
															</div>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col-sm-6">
														<div class="form-group">
															<label class="col-sm-3 control-label"><span class="required">*</span>课件类型</label>
															<div class="col-sm-9">
																<select class="form-control" v-model="lesson.lesson_filetype">
																	<option value="av">音频/视频（mp3/mp4/wmv/rmvb/flv/mpeg/wav）</option>
																</select>
															</div>
														</div>
													</div>
													<div class="col-sm-6">
														<div class="form-group">
															<label class="col-sm-3 control-label"><span class="required">*</span>课时长度</label>
															<div class="col-sm-6">
																<input type="text" v-model="lesson.lesson_minutes" v-validate="{required:true}" :name="'lesson_minutes'+indexb" class="form-control" data-vv-as="课时长度"     />
																<span class="error_validate_msg"><em>{{ errors.first('lesson_minutes'+indexb) }}</em></span>
															</div>
															<div class="col-sm-2" style="padding-left:0px">
																分钟
															</div>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col-sm-9">
														<div class="form-group">
															<label class="col-sm-2 control-label"><span class="required">*</span>课件地址</label>
															<div class="col-sm-9">
																<input type="text" v-model="lesson.lesson_filepath" v-validate="{required:true}" :name="'lesson_filepath'+indexb" class="form-control" data-vv-as="课件地址"     />
																<span class="error_validate_msg"><em>{{ errors.first('lesson_filepath'+indexb) }}</em></span>
															</div>
															<div class="col-sm-1">
																<CoursewareUpload id="upload_btn" :accept="['mp3','mp4','wmv','rmvb','flv','mpeg','wav']" @uploadSuccess="uploadSuccess($event, lesson)"></CoursewareUpload>
															</div>
														</div>
													</div>
												</div>
											</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				</template>

				<!-- 批量导入操作 -->
				<div class="panel panel-primary" v-if="action == 'import'" style="margin: 15px;padding: 10px;">
					<div>
						<div>
							 请先下载导入模板，并按照格式填写，填写完成后，上传文件即可完成导入。
						</div>
						<div class="text-danger">
							按照模板填写好课件章节信息，就可以批量导入。
						</div>
					</div>
					<div>
						<form role="form" class="form-horizontal" style="margin-top: 10px;">
							<div class="form-group">
							    <label class="col-sm-2 control-label">请选择文件</label>
							    <div class="col-sm-5">
							        <file-upload id="cj_bmxx_weihu_fp" :accept="['xls','xlsx']" @fileselected="fileselected"></file-upload>
							    </div>
							    <div class="col-sm-10 col-sm-offset-2" style="padding-top: 6px">
							        <a href="/templates/template_courseware.xls" style="text-decoration: underline">(点击下载导入模板)</a>
							    </div>
							</div>
						</form>
					</div>
				</div>

				<div class="row">
					<div class="col-sm-12 text-center">
						<button @click="save()" type="button" class="btn btn-primary btn-sm ">保存</button>
						<button @click="goback()" type="button" class="btn btn-primary btn-sm " style="margin-left:10px">返回</button>
					</div>
				</div>

			</div>
		</div>


	</div>
</template>
<script>
	/**
	 * 课件管理-新增课件
	 */
export default {
	name:"ZypxCourseLearnEdit",
	components:{
	},
	data:function(){
		return {
			query:{
				lxId:null
			},
			kcList:[],
			kjFile:null,
			chapterList:[],
			action:'form',
			model:{
				id:this.$route.query.id,
				kcId:'',
				jsxm:'',
				kjdw:'',
				zt:'OK',
				kjjs:'',
				jsjj:''
			}
		}
	},
	created:function(){
		this.$store.commit('setBreadcrumb', [{name: '基础数据'}, {name: '资源管理'}, {name: '课件管理'},{name:'修改课件'}]);
		this.$store.commit('setShowReturnBackBtn',true);
		this.getkcList();
		this.$http.post('/htgl/inf/zypx/kj/hq',{id:this.model.id}).then(res=>{
			if(res.data){
				this.model.id = res.data.id;
				this.model.kcId = res.data.kc_id;
				this.model.jsxm = res.data.jsxm;
				this.model.kjdw = res.data.kjdw;
				this.model.zt = res.data.zt;
				this.model.kjjs = res.data.kjjs;
				this.chapterList = res.data.chapters;
				this.query.lxId = res.data.lx_id || null;
				this.model.jsjj = res.data.jsjj || null;
			}
		});
	},
	methods:{
		// 返回
		getReturn: function() {
			this.$router.go(-1);
		},
		fileselected:function(file){
			console.log('-----file:',file);
		    this.kjFile = file;
		},
		changeToggle:function(m){
			this.action = m;
		},
		save:function(){
			if(this.action == 'form') {
				this.saveForm();
			}
			if(this.action == 'import') {
				this.saveImport();
			}
		},
		saveForm:function(){
			this.$validator.validateAll().then((result) => {
			    if (result) {//如果表单校验通过才可以保存
					//参数处理
					let params = {};
					params.id = this.model.id;
					if(!params.id){
						this.$error('课件ID缺失');
						return;
					}
					params.kcId = this.model.kcId;
					if(!params.kcId){
						this.$error('请选择课程');
						return;
					}
					params.jsxm = this.model.jsxm;
					if(!params.jsxm){
						this.$error('请输入课件讲师');
						return;
					}
					params.kjdw = this.model.kjdw || '';
					params.zt = this.model.zt;
					if(!params.zt){
						this.$error('请选择课件状态');
						return;
					}
					params.kjjs = this.model.kjjs;
					params.jsjj = this.model.jsjj || '';
					if(!this.chapterList || this.chapterList.length == 0){
						this.$error('请输入章节课时信息');
						return;
					}
					else{
						let chapterList = [];
						for (let i=0;i<this.chapterList.length;i++) {
							let var_chapter = this.chapterList[i];
							if(!var_chapter || !var_chapter.name){
								this.$error('第'+(i+1)+'章缺少章节名称');
								return;
							}
							else{
								let param_chapter = {};
								param_chapter.name = var_chapter.name;
								param_chapter.id = var_chapter.id || '';
								let lessons = var_chapter.lessons;
								if(!lessons || lessons.length == 0){
									this.$error('第'+(i+1)+'章请填入课时信息');
									return;
								}
								else{
									param_chapter.lessons = [];
									for (let j=0;j<lessons.length;j++) {
										let lesson = lessons[j];
										if(!lesson || !lesson.lesson_name){
											this.$error('第'+(i+1)+'章，第'+(j+1)+'课时请填入课时名称');
											return;
										}
										if(!lesson || !lesson.lesson_remark){
											this.$error('第'+(i+1)+'章，第'+(j+1)+'课时请填入课时介绍');
											return;
										}
										if(!lesson || !lesson.lesson_filetype){
											this.$error('第'+(i+1)+'章，第'+(j+1)+'课时请选择课件类型');
											return;
										}
										if(!lesson || !lesson.lesson_minutes){
											this.$error('第'+(i+1)+'章，第'+(j+1)+'课时请填入课时长度');
											return;
										}
										if(!lesson || !lesson.lesson_filepath){
											this.$error('第'+(i+1)+'章，第'+(j+1)+'课时请填入课件地址');
											return;
										}
										//ok
										let lesson_id = lesson.id || '';
										param_chapter.lessons.push({
											id:lesson_id,
											lesson_name:lesson.lesson_name,
											lesson_remark:lesson.lesson_remark,
											lesson_filetype:lesson.lesson_filetype,
											lesson_minutes:lesson.lesson_minutes,
											lesson_filepath:lesson.lesson_filepath
										});
									}
									chapterList.push(param_chapter);
								}
							}
						}
						if(!chapterList || chapterList.length == 0){
							this.$error('缺少章节课时信息，请仔细检查');
						}
						else{
							params.chapters = chapterList;
						}
					}
					//参数校验完毕 提交
			        this.$http.post('/htgl/inf/zypx/kj/xg',JSON.stringify(params),{'Content-Type':'application/json;charset=UTF-8'}).then(res=>{
			            if(res.data){
							this.$success('操作成功',()=>{
								this.$router.go(-1);
							});
			            }
			        })
			    }
			})
		},
		saveImport:function() {
			this.$validator.validateAll().then(result=>{
				if(result) {
					let params = {};
					if(!this.kjFile) {
						this.$error('请上传文件');
						return;
					}
					else{
						params.file = this.kjFile;
					}
					params.id = this.model.id;
					if(!params.id){
						this.$error('课件ID缺失');
						return;
					}
					//参数处理
					params.kcId = this.model.kcId;
					if(!params.kcId){
						this.$error('请选择课程');
						return;
					}
					params.jsxm = this.model.jsxm;
					if(!params.jsxm){
						this.$error('请输入课件讲师');
						return;
					}
					params.kjdw = this.model.kjdw || '';
					params.zt = this.model.zt;
					if(!params.zt){
						this.$error('请选择课件状态');
						return;
					}
					params.kjjs = this.model.kjjs;
					params.jsjj = this.model.jsjj || '';
					let formdata = new FormData();
					for (let p in params) {
						formdata.append(p, params[p]);
					}
					this.$http.post("/htgl/inf/zypx/kj/dr",formdata,{'Content-Type':'multipart/form-data'}).then(res=>{
					    if (res.code ==0) {
					       this.$success('操作成功',()=>{
								this.$router.go(-1);
					       });
					    }
					})
				}
			})
		},
		goback:function(){
			this.$router.go(-1);
		},
		addChapter:function(){
			this.chapterList.push({
				name:'',
				lessons:[
					{
						lesson_name:'',
						lesson_remark:'',
						lesson_filetype:'av',
						lesson_minutes:'',
						lesson_filepath:''
					}
				]
			})
		},
		delChapter:function(index){
			if(this.chapterList && this.chapterList.length > 1){
				this.chapterList.splice(index,1);
			}
			else{
				this.$error('至少要有一个章节');
			}
		},
		addLesson:function(chapter){
			chapter.lessons = chapter.lessons || [];
			chapter.lessons.push({
				lesson_name:'',
				lesson_remark:'',
				lesson_filetype:'av',
				lesson_minutes:'',
				lesson_filepath:''
			})
		},
		delLesson:function(lessons, index){
			if(lessons && lessons.length > 1){
				lessons.splice(index,1);
			}
			else{
				this.$error('每章至少要有一个课时');
			}
		},
		uploadSuccess:function(event,obj){
			if(event){
				obj.lesson_minutes = event.minutes;
				obj.lesson_filepath = event.url;
			}
		},
		showOption:function(item){
		    return item.kcdm + '-' + item.kcmc;
		},
		showKjdwOption:function(item){
		    return item.jgdm + '-' + item.jgmc;
		},
		//获取课程列表
		getkcList: function (node) {
			let lxId = null;
			if(node){
				lxId = node.id;
				this.model.kcId = '';
			}
			this.$http.post('/htgl/inf/zypx/kj/hqkc',{lxId:lxId}).then(res => {
				if(res.data){
					this.kcList = res.data;
				}
			});
		}
	}
}
</script>
<style>

</style>
